/** Pusher / Reverb connection phase exposed to widget UI. */
export type RealtimeConnectionPhase =
  | 'idle'
  | 'connecting'
  | 'connected'
  | 'disconnected'
  | 'unavailable';

export function mapPusherConnectionState(
  current: string,
): RealtimeConnectionPhase {
  switch (current) {
    case 'connecting':
      return 'connecting';
    case 'connected':
      return 'connected';
    case 'disconnected':
      return 'disconnected';
    case 'unavailable':
      return 'unavailable';
    default:
      return 'idle';
  }
}
